import React from 'react';
import './minimalHome.css';



const Body = () => {




  return (
    <main className="minimal-home" aria-label="Ocarin landing page">
      <p style={{ fontSize: '30px', marginTop: '3%', border: 'solid 1px', padding:'50px', width:'50vw' }}> 
          I make games.
          <br />
          <br />
          <br />
          <br />
          Working on{' '}
          <a
              href="https://store.steampowered.com/app/4541290/FISH_KISSER/?l=english"
              target="_blank"
              rel="noopener noreferrer"
          >
              FISH KISSER
          </a>{' '}
          and{' '}
          <a
              href="https://darkmountaingame.github.io"
              target="_blank"
              rel="noopener noreferrer"
          >
              Dark Mountain
          </a>
          .
          <br/>
          <br/>
          I have{' '}
          <a
              href="https://x.com/xOcarin_"
              target="_blank"
              rel="noopener noreferrer"
          >
              Twitter
          </a>{' '}
          and{' '}
          <a
              href="https://www.youtube.com/@Ocarin_"
              target="_blank"
              rel="noopener noreferrer"
          >
              Youtube
          </a>
          .
          <br />
          <br />
          <br />
          <br />
          Contact me: xOcarin@gmail.com
      </p>   
    </main>
  );
};

export default Body;
